export const environment = {
  production: true,
  apiUrl: 'https://mpgpsr-dev.spe.sony.com/app/api',
  reportUrl: 'https://mpgpsr-dev.spe.sony.com/app/report',
  baseUrl: 'https://mpgpsr-dev.spe.sony.com',
  config: {
    "aws_project_region": "us-west-2",
  "aws_cognito_region": "us-west-2",
  "aws_user_pools_id": "us-west-2_dUb1sQq10",
  "aws_user_pools_web_client_id": "6p3uepqf743tdfprg18tq4mlv4",
  "oauth": {
      "domain": "mpgpsr-domain-dev.auth.us-west-2.amazoncognito.com",
      "scope": [
          "email",
          "openid",
          "profile",
          "aws.cognito.signin.user.admin"
      ],
      "redirectSignIn": "https://mpgpsr-dev.spe.sony.com/",
      "redirectSignOut": "https://sso-qa.spe.sony.com/affwebservices/redirectjsp/MPG/logout.jsp",
      "responseType": "code"
  }
}
};
